import axios from 'axios'
import authHeader from '@/services/auth-header'

const baseUrl = `${process.env.VUE_APP_API_URL}administrativo/estrutura-organizacional`

export default {
  tree () {
    return axios.get(`${baseUrl}/tree`, { headers: authHeader() })
  },

  activePeople (functionId) {
    return axios.get(`${baseUrl}/functions/${functionId}/active-people`, { headers: authHeader() })
  },

  catalog () {
    return axios.get(`${baseUrl}/catalog`, { headers: authHeader() })
  },

  show (type, id) {
    return axios.get(`${baseUrl}/items/${type}/${id}`, { headers: authHeader() })
  },

  create (type, payload) {
    return axios.post(`${baseUrl}/${this.resource(type)}`, payload, { headers: authHeader() })
  },

  update (type, id, payload) {
    return axios.put(`${baseUrl}/${this.resource(type)}/${id}`, payload, { headers: authHeader() })
  },

  deactivate (type, id, reason, expectedUpdatedAt) {
    return axios.post(`${baseUrl}/${type}/${id}/deactivate`, { reason, expected_updated_at: expectedUpdatedAt }, { headers: authHeader() })
  },

  restore (type, id, reason, expectedUpdatedAt) {
    return axios.post(`${baseUrl}/${type}/${id}/restore`, { reason, expected_updated_at: expectedUpdatedAt }, { headers: authHeader() })
  },

  permissions (functionId) {
    return axios.get(`${baseUrl}/functions/${functionId}/permissions`, { headers: authHeader() })
  },

  syncPermissions (functionId, permissionIds, homePermissionIds, reason, expectedUpdatedAt) {
    return axios.put(`${baseUrl}/functions/${functionId}/permissions`, {
      permission_ids: permissionIds,
      home_permission_ids: homePermissionIds,
      reason,
      expected_updated_at: expectedUpdatedAt
    }, { headers: authHeader() })
  },

  clonePermissions (functionId, sourceFunctionId, reason, expectedUpdatedAt) {
    return axios.post(`${baseUrl}/functions/${functionId}/permissions/clone`, {
      source_function_id: sourceFunctionId,
      reason,
      expected_updated_at: expectedUpdatedAt
    }, { headers: authHeader() })
  },

  cloneActivityPermissions (functionId, sourceFunctionId, reason, expectedUpdatedAt) {
    return axios.post(`${baseUrl}/functions/${functionId}/activity-permissions/clone`, {
      source_function_id: sourceFunctionId,
      reason,
      expected_updated_at: expectedUpdatedAt
    }, { headers: authHeader() })
  },

  resource (type) {
    return { department: 'departments', sector: 'sectors', function: 'functions' }[type]
  }
}
